export type RuntimeTarget = 'web' | 'desktop'

const runtimeTargetEnv = process.env.NEXT_PUBLIC_RUNTIME_TARGET

export const runtimeTarget: RuntimeTarget =
  runtimeTargetEnv === 'desktop' ? 'desktop' : 'web'

export const isDesktopRuntime = runtimeTarget === 'desktop'
